import { BaseEntity } from "../baseEntity";
import {
  Media,
  MediaType,
  Resolution,
  MediaLanguage,
  MediaResource,
} from "../../../types/cms/CmsMediaType";

export interface ILanguageBlock {
  language: string;
}
export enum MediaResourceType {
  Native = "native",
  External = "external",
}
export interface IMediaResource {
  mediaResourceId: string;
  type: MediaResourceType;
  protocol: string;
  url: string;
  isEncrypted?: boolean;
  createdAt: string;
  updatedAt: string;
}

export enum MediaResourceProtocol {
  HLS = "hls",
  DASH = "dash",
  Other = "other",
}

export enum CMSMediaType {
  Main = "main",
  Trailer = "trailer",
  Clip = "clip",
  Channel = "channel",
  Other = "other",
}

export enum VideoResolution {
  SD = "SD",
  HD = "HD",
  UHD = "UHD",
}

export class CMSMedia implements Media {
  mediaId: string;
  type: MediaType;
  name: string;
  videoResolution: Resolution;
  durationMillis: number;
  videoWidth: number;
  videoHeight: number;
  multiChannelAudio: boolean;
  spokenLanguage: string;
  audioLanguages: MediaLanguage[];
  subtitleLanguages: MediaLanguage[];
  hardOfHearing: boolean;
  enabled: boolean;
  mediaResources: MediaResource[];
  createdAt: string;
  updatedAt: string;

  constructor(media: Media) {
    Object.assign(this, media);
  }

  getUniqueId(): string {
    return this.mediaId;
  }

  getType(): string {
    return this.type;
  }

  getDisplayName(): string {
    return this.name || this.getUniqueId();
  }

  get isPublished() {
    return this.enabled;
  }
}
